import { create } from 'zustand'

const STORAGE_KEY = 'osprey.sidebarCollapsed'

/**
 * Read the persisted collapse choice. Wrapped because Safari private mode throws on
 * localStorage access rather than returning null, and the shell must still render.
 */
const readCollapsed = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

const writeCollapsed = (value: boolean) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(value))
  } catch {
    /* storage unavailable — the choice just won't survive a reload */
  }
}

interface NavigationState {
  /** Desktop-only: the sidebar is collapsed out of the flow (mobile uses its own overlay state). */
  sidebarCollapsed: boolean
  toggleSidebarCollapsed: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
}

export const useNavigationStore = create<NavigationState>((set) => ({
  sidebarCollapsed: readCollapsed(),
  toggleSidebarCollapsed: () =>
    set((state) => {
      const next = !state.sidebarCollapsed
      writeCollapsed(next)
      return { sidebarCollapsed: next }
    }),
  setSidebarCollapsed: (collapsed) => {
    writeCollapsed(collapsed)
    set({ sidebarCollapsed: collapsed })
  },
}))
